// removed by extract-text-webpack-plugin
module.exports = {"textEllipsis":"_27-_lFmNC4c7sdQwMvb9pS","resetTextMargin":"_3R2OUDtIpa4eT63bpyCzht","dataText":"_3o5mWvgwvIzgvN9Shcj-F1","item":"QruhwdW8TPPbvLhP00a6J","active":"_3Un4bNs-IIkskCnMJtTPUD"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Search/Customer/Item/style.css
// module id = 2427
// module chunks = 0